export function dataInRequest(params = {}) {
  return {
    type: '@tiposDeEquipamentosVeiculo/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@tiposDeEquipamentosVeiculo/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@tiposDeEquipamentosVeiculo/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@tiposDeEquipamentosVeiculo/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@tiposDeEquipamentosVeiculo/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@tiposDeEquipamentosVeiculo/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@tiposDeEquipamentosVeiculo/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@tiposDeEquipamentosVeiculo/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@tiposDeEquipamentosVeiculo/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@tiposDeEquipamentosVeiculo/RECORD_FILTERING',
    payload: { params },
  };
}
